import { render } from "./Footer.vue?vue&type=template&id=66ecf7f1"
const script = {}

import exportComponent from "/opt/render/project/src/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__